import type { NotificationField } from '../types'

/** Uses the default noun when a configured label is blank. */
function customizedLabel(value: string, fallback: string) {
  return value.trim() ? value : fallback
}

/**
 * Resolves selectable-field vocabulary used by notification conditions.
 *
 * Missing or disabled custom labels use the default option nouns.
 */
export function optionFieldSettings(field: NotificationField | undefined) {
  if (
    field?.settings.type !== 'approvals' &&
    field?.settings.type !== 'selected_by'
  )
    return { plural: 'Options', single: false, singular: 'Option' }

  const { customizeOptionLabel } = field.settings
  const single = field.settings.type === 'selected_by' || field.settings.single
  if (!customizeOptionLabel?.enabled)
    return {
      plural: 'Options',
      single,
      singular: 'Option',
    }

  return {
    plural: customizedLabel(customizeOptionLabel.plural, 'Options'),
    single,
    singular: customizedLabel(customizeOptionLabel.singular, 'Option'),
  }
}
